var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mailing"},[_c('h1',{staticClass:"page-title"},[_vm._v("Розсилки")])])
}]

export { render, staticRenderFns }